import { render, staticRenderFns } from "./OverlayGameRoomDebug.vue?vue&type=template&id=d2c1faa4&"
import script from "./OverlayGameRoomDebug.vue?vue&type=script&lang=ts&"
export * from "./OverlayGameRoomDebug.vue?vue&type=script&lang=ts&"
import style0 from "./OverlayGameRoomDebug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports